/* @flow */

import React from 'react';
import glamorous from 'glamorous';
import * as cssUtils from 'app/utils/cssUtils';
import { padding, tint } from 'polished';
import Tappable from 'app/components/commons/Tappable';

type Props = {
  onClick: () => void,
  title: string,
};

const Button = glamorous(Tappable)(props => ({
  alignItems: 'center',
  backgroundColor: '#191d2c',
  color: 'white',
  cursor: 'pointer',
  display: 'flex',
  flexBasis: '100%',
  letterSpacing: '0.3em',
  ...padding('2rem'),
  textAlign: 'center',
  justifyContent: 'center',
  [props.theme.mediaQuery.tabletPortraitAndUp]: {
    ...padding(null, '3rem'),
  },
  [props.theme.mediaQuery.desktopAndUp]: {
    // alignItems: 'flex-start',
    backgroundColor: props.theme.color.primary,
    justifyContent: 'center',
    letterSpacing: '0.1em',
    ...padding('0.75rem', '1rem'),
    transition: 'background-color 0.2s',
    ...cssUtils.hover({
      backgroundColor: tint(0.75, props.theme.color.primary),
    }),
  },
}));

function HowToPlayButton({ onClick, title }: Props) {
  return <Button onClick={onClick}>{title}</Button>;
}

export default HowToPlayButton;
